import React, { useState, useEffect } from 'react';
import Sentry from '../Sentry'

export function WriteLogs( isError, message, enableConsoleLogging, enableSentryLogging, enableAlertLogging ) {

    if (enableConsoleLogging) {
        console.log(message)
    }

    if (enableSentryLogging && isError) {
        Sentry.captureException(message)
    }

    if (enableSentryLogging && !isError) {
        Sentry.captureMessage(message)
    }

    if (enableAlertLogging) {
        alert(message)
    }

}

